// 502, 503 и 504 у сервисов распознавания отдаёт прокси, а не сам сервис: тела
// с `detail` нет, и на экран уходил текст axios «Request failed with status code
// 502». 21.10.2026 так выглядела для человека авария видеокарты под диаризацией:
// ни что случилось, ни что делать.

export const UNAVAILABLE_MESSAGE =
  'Сервис распознавания сейчас недоступен. Попробуйте через '
  + 'несколько минут; если ошибка повторяется — напишите нам через «Проблема или идея».';

const GATEWAY_STATUSES = new Set([502, 503, 504]);

/** Ответ прокси без слов сервиса → человеческий текст; иначе null. */
export function unavailableText(e) {
  if (e?.response?.data?.detail) return null;
  return GATEWAY_STATUSES.has(e?.response?.status) ? UNAVAILABLE_MESSAGE : null;
}
